// PRD §3.1 — 15 standard ICD-10 chapters used by the Disease Group form's hybrid
// range input. The dropdown is UI-only (PRD §4.1 "Storage Rule"): selection
// auto-fills rangeStart/rangeEnd and (only if empty) the group name. Stored
// values are the final `rangeStart` / `rangeEnd`, which the user may edit.

export interface IcdChapter {
  // Single-letter key used as the `<option value>` and the i18n lookup key
  // (`diseaseCodeManagement.icdChapters.{letter}`).
  letter: string;
  rangeStart: string;
  rangeEnd: string;
}

export const ICD_CHAPTERS: readonly IcdChapter[] = [
  { letter: 'A', rangeStart: 'A00', rangeEnd: 'B99' },
  { letter: 'C', rangeStart: 'C00', rangeEnd: 'D48' },
  { letter: 'D', rangeStart: 'D50', rangeEnd: 'D89' },
  { letter: 'E', rangeStart: 'E00', rangeEnd: 'E99' },
  { letter: 'F', rangeStart: 'F00', rangeEnd: 'F99' },
  { letter: 'G', rangeStart: 'G00', rangeEnd: 'G99' },
  { letter: 'H', rangeStart: 'H00', rangeEnd: 'H59' },
  { letter: 'I', rangeStart: 'I00', rangeEnd: 'I99' },
  { letter: 'J', rangeStart: 'J00', rangeEnd: 'J99' },
  { letter: 'K', rangeStart: 'K00', rangeEnd: 'K93' },
  { letter: 'L', rangeStart: 'L00', rangeEnd: 'L99' },
  { letter: 'M', rangeStart: 'M00', rangeEnd: 'M99' },
  { letter: 'N', rangeStart: 'N00', rangeEnd: 'N99' },
  { letter: 'R', rangeStart: 'R00', rangeEnd: 'R99' },
  { letter: 'S', rangeStart: 'S00', rangeEnd: 'T98' },
] as const;
